<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>

            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.showId' clearable
                                                      :placeholder="$t('类型') " style='width:120px'>
              <Option :value="0">{{ $t('新澳门') }}</Option>


              <Option :value="1">{{ $t('香港') }}</Option>


              <Option :value="2">{{ $t('老澳门') }}</Option>


              <Option :value="3">{{ $t('新加坡') }}</Option>


              <Option :value="4">{{ $t('柬埔寨') }}</Option>


              <Option :value="5">{{ $t('台湾') }}</Option>


              <Option :value="6">{{ $t('印尼') }}</Option>


              <Option :value="7">{{ $t('马来西亚') }}</Option>


            </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.isOpen' clearable
                      :placeholder="$t('是否启用') " style='width:120px'>
                <Option :value="-1">{{ $t('全部') }}</Option>
                <Option :value="1">{{ $t('启用') }}</Option>
                <Option :value="0">{{ $t('不启用') }}</Option>
              </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.isShowOnIndex' clearable
                      :placeholder="$t('是否首页显示') " style='width:150px'>
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.isShowOnBbs' clearable
                      :placeholder="$t('是否帖子页显示') " style='width:150px'>
                <Option :value="1">{{ $t('显示') }}</Option>
                <Option :value="0">{{ $t('不显示') }}</Option>
              </Select>
            </FormItem>


            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.moduleName' :placeholder="$t('模块名称') "></Input>
            </FormItem>

            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="resortIndex(1)">{{ $t("一键首页重排") }}</Button>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="resortIndex(0)">{{ $t("一键帖子页重排") }}</Button>
            </FormItem>
			<FormItem class='margin-bottom-0'>
			</FormItem>
<!--            <FormItem class="margin-bottom-0">-->
<!--              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>-->
<!--            </FormItem>-->
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'LhcManage/LhcOpenLog/add'" @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='colHidden' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label='香港首页排序' prop='indexOrderXg'>
          <Input clearable v-model='windowAddItem.indexOrderXg' :placeholder="$t('请输入香港首页排序')"></Input>
        </FormItem>
        <FormItem label='香港帖子页排序' prop='bbsOrderXg'>
          <Input clearable v-model='windowAddItem.bbsOrderXg' :placeholder="$t('请输入香港帖子页排序')"></Input>
        </FormItem>
        <FormItem label='澳门首页排序' prop='indexOrderAm'>
          <Input clearable v-model='windowAddItem.indexOrderAm' :placeholder="$t('请输入澳门首页排序')"></Input>
        </FormItem>
        <FormItem label='澳门帖子页排序' prop='bbsOrderAm'>
          <Input clearable v-model='windowAddItem.bbsOrderAm' :placeholder="$t('请输入澳门帖子页排序')"></Input>
        </FormItem>

      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  moduleDataGetList,
  moduleDataEdit,
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data() {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      searchConf: {searchTime: [],isOpen:1,showId:-1,isShowOnBbs:-1,isShowOnIndex:-1,isIndex:1}, // 搜索字段
      columnsList: [ {
        title: '序号',
        type: 'index',
        width: 40,
        align: 'center'
      },{
        title: '显示排序',
        sortable: true,
        key: 'showOrder',
        align: 'center',
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.showOrder,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('Lhc/moduleDataEdit', {id:params.row.id,showOrder:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      },{
        title: 'ID',
        key: 'id',
        width: 40,
        align: 'center'
      },{
        title: '模块启用',
        sortable: true,
        align: 'center',
        width: 80,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isOpen,
            },
            on: {
              'on-change': function (status) {
                moduleDataEdit({id:params.row.id,isOpen:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "启用"),
            h('span', {
              slot: 'close'
            }, "禁用")
          ])
        }
      },{
        title: this.$t('模块名称'),
        key: 'moduleName',
        minWidth: 90,
        align: 'center'
      }, {
        title: '香港首页',
        sortable: true,
        hidden:1,
        align: 'center',
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isShowIndex_1,
            },
            on: {
              'on-change': function (status) {
                moduleDataEdit({id:params.row.id,isShowIndex_1:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "显示"),
            h('span', {
              slot: 'close'
            }, "不显")
          ])
        }
      },{
        title: '香港帖子页',
        sortable: true,
        hidden:1,
        align: 'center',
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isShowBbs_1,
            },
            on: {
              'on-change': function (status) {
                moduleDataEdit({id:params.row.id,isShowBbs_1:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "显示"),
            h('span', {
              slot: 'close'
            }, "不显")
          ])
        }
      },{
        title: '新澳门首页',
        align: 'center',
        hidden:0,
        sortable: true,
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isShowIndex_0,
            },
            on: {
              'on-change': function (status) {
                moduleDataEdit({id:params.row.id,isShowIndex_0:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "显示"),
            h('span', {
              slot: 'close'
            }, "不显")
          ])
        }
      },{
        title: '新澳门帖子页',
        align: 'center',
        sortable: true,
        hidden:0,
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isShowBbs_0,
            },
            on: {
              'on-change': function (status) {
                moduleDataEdit({id:params.row.id,isShowBbs_0:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "显示"),
            h('span', {
              slot: 'close'
            }, "不显")
          ])
        }
      }, {
        title: '老澳门首页',
        sortable: true,
        hidden:2,
        align: 'center',
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isShowIndex_2,
            },
            on: {
              'on-change': function (status) {
                moduleDataEdit({id:params.row.id,isShowIndex_2:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "显示"),
            h('span', {
              slot: 'close'
            }, "不显")
          ])
        }
      },{
        title: '老澳门帖子页',
        sortable: true,
        hidden:2,
        align: 'center',
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.isShowBbs_2,
            },
            on: {
              'on-change': function (status) {
                moduleDataEdit({id:params.row.id,isShowBbs_2:status}).then(response => {
                  vm.$Message.success(response.data.msg)
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, "显示"),
            h('span', {
              slot: 'close'
            }, "不显")
          ])
        }
      },
        {
          title: '新加坡首页',
          sortable: true,
          align: 'center',
          hidden:3,
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowIndex_3,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowIndex_3:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },{
          title: '新加坡帖子页',
          sortable: true,
          hidden:3,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowBbs_3,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowBbs_3:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },

        {
          title: '柬埔寨首页',
          sortable: true,
          align: 'center',
          hidden:4,
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowIndex_4,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowIndex_4:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },{
          title: '柬埔寨帖子页',
          sortable: true,
          hidden:4,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowBbs_4,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowBbs_4:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },

        {
          title: '台湾首页',
          sortable: true,
          hidden:5,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowIndex_5,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowIndex_5:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },{
          title: '台湾帖子页',
          sortable: true,
          hidden:5,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowBbs_5,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowBbs_5:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },


        {
          title: '印尼首页',
          sortable: true,
          align: 'center',
          hidden:6,
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowIndex_6,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowIndex_6:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },{
          title: '印尼帖子页',
          hidden: 6,
          sortable: true,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowBbs_6,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowBbs_6:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },

        {
          title: '马来西亚首页',
          sortable: true,
          align: 'center',
          hidden:7,
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowIndex_7,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowIndex_7:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },{
          title: '马来西亚帖子页',
          sortable: true,
          align: 'center',
          hidden:7,
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('i-switch', {
              attrs: {
                size: 'large'
              },
              props: {
                'true-value': 1,
                'false-value': 0,
                value: params.row.isShowBbs_7,
              },
              on: {
                'on-change': function (status) {
                  moduleDataEdit({id:params.row.id,isShowBbs_7:status}).then(response => {
                    vm.$Message.success(response.data.msg)
                  })
                }
              }
            }, [
              h('span', {
                slot: 'open'
              }, "显示"),
              h('span', {
                slot: 'close'
              }, "不显")
            ])
          }
        },


        {
          title: '香港首页排序',
          sortable: true,
        key: 'indexOrder_1',
          align: 'center',
          hidden:1,
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.indexOrder_1,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,indexOrder_1:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        }, {
        title: '香港帖子排序',
        sortable: true,
        key: 'bbsOrder_1',
          hidden:1,
        align: 'center',
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.bbsOrder_1,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('Lhc/moduleDataEdit', {id:params.row.id,bbsOrder_1:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      },{
        title: '新澳门首页排序',
        sortable: true,
        key: 'indexOrder_0',
          hidden:0,
        align: 'center',
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.indexOrder_0,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('Lhc/moduleDataEdit', {id:params.row.id,indexOrder_0:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      }, {
        title: '新澳门帖子排序',
        sortable: true,
        key: 'bbsOrder_0',
        align: 'center',
          hidden:0,
        width: 85,
        render: (h, params) => {
          let vm = this
          return h('InputNumber', {
            props: {
              value: params.row.bbsOrder_0,
            },
            on: {
              'on-change': function (data) {
                let vm = this
                customPost('Lhc/moduleDataEdit', {id:params.row.id,bbsOrder_0:data}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList()
                }).catch(() => {

                })
              }
            }
          })
        }
      },

        {
          title: '老澳门首页排序',
          sortable: true,
          key: 'indexOrder_2',
          hidden:2,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.indexOrder_2,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,indexOrder_2:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        }, {
          title: '老澳门帖子排序',
          sortable: true,
          hidden:2,
          key: 'bbsOrder_2',
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.bbsOrder_2,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,bbsOrder_2:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        },

        {
          title: '新加坡首页排序',
          sortable: true,
          key: 'indexOrder_3',
          hidden:3,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.indexOrder_3,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,indexOrder_3:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        }, {
          title: '新加坡帖子排序',
          sortable: true,
          hidden:3,
          key: 'bbsOrder_3',
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.bbsOrder_3,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,bbsOrder_3:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        },

        {
          title: '柬埔寨首页排序',
          sortable: true,
          key: 'indexOrder_4',
          hidden:4,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.indexOrder_4,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,indexOrder_4:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        }, {
          title: '柬埔寨帖子排序',
          sortable: true,
          key: 'bbsOrder_4',
          hidden:4,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.bbsOrder_4,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,bbsOrder_4:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        },

        {
          title: '台湾首页排序',
          sortable: true,
          key: 'indexOrder_5',
          hidden:5,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.indexOrder_5,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,indexOrder_5:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        }, {
          title: '台湾帖子排序',
          sortable: true,
          key: 'bbsOrder_5',
          hidden:5,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.bbsOrder_5,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,bbsOrder_5:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        },

        {
          title: '印尼首页排序',
          sortable: true,
          hidden:6,
          key: 'indexOrder_6',
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.indexOrder_6,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,indexOrder_6:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        }, {
          title: '印尼帖子排序',
          sortable: true,
          key: 'bbsOrder_6',
          hidden:6,
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.bbsOrder_6,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,bbsOrder_6:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        },

        {
          title: '马来西亚首页排序',
          sortable: true,
          hidden:7,
          key: 'indexOrder_7',
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.indexOrder_7,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,indexOrder_7:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        }, {
          title: '马来西亚帖子排序',
          sortable: true,
          hidden:7,
          key: 'bbsOrder_7',
          align: 'center',
          width: 85,
          render: (h, params) => {
            let vm = this
            return h('InputNumber', {
              props: {
                value: params.row.bbsOrder_7,
              },
              on: {
                'on-change': function (data) {
                  let vm = this
                  customPost('Lhc/moduleDataEdit', {id:params.row.id,bbsOrder_7:data}).then(response => {
                    vm.$Message.success(response.data.msg)
                    vm.getList()
                  }).catch(() => {

                  })
                }
              }
            })
          }
        },
      //   {
      //   title: this.$t('操作'),
      //   align: 'center',
      //   minWidth: 120,
      //   render: (h, params) => {
      //     let vm = this
      //     return h('div', [h('Button', {
      //       props: {
      //         type: 'primary'
      //       },
      //       style: {
      //         margin: '0 5px'
      //       },
      //       on: {
      //         'click': () => {
      //           let vm = this
      //           vm.windowAddItem.id=params.row.id;
      //           vm.windowAddItem.bbsOrderAm=params.row.bbsOrderAm;
      //           vm.windowAddItem.bbsOrderXg=params.row.bbsOrderXg;
      //           vm.windowAddItem.indexOrderAm=params.row.indexOrderAm;
      //           vm.windowAddItem.indexOrderXg=params.row.indexOrderXg;
      //           vm.windowAdd.show = true
      //         }
      //       }
      //     }, this.$t('编辑')),])
      //   }
      // },
       ],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 100,
        listCount: 0
      },

      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },
      //----------------

    }
  },
  computed: {
    colHidden: function () { //重点
      var  that=this;
      return this.columnsList.filter(function (e) {
        return e.hidden==that.searchConf.showId || e.hidden==null;
      });
    }
  },
  created() {
    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcOpenLog/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcOpenLog/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcOpenLog/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted() {
    this.getParams()
  },
  methods: {
    preAdd() {
      let vm = this
      vm.windowAddItem.id=0;
      vm.windowAddItem.bbsOrderAm='';
      vm.windowAddItem.bbsOrderXg='';
      vm.windowAddItem.indexOrderAm='';
      vm.windowAddItem.indexOrderXg='';
      vm.windowAdd.show = true
    },
    getParams() {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    resortIndex(isIndex) {
      this.searchConf.isIndex=isIndex;
      customPost('Lhc/moduleDataSort', this.searchConf).then(response => {
        this.$Message.success(response.data.msg)
        this.getList()
      }).catch(() => {

      })
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page= vm.tableShow.currentPage
      vm.searchConf.size= vm.tableShow.pageSize
      // this.colHidden = function () { //重点
      //   return this.columnsList.filter(function (e) {
      //     return !e.hidden;
      //   });
      // }
      // this.columnsList=this.colHidden;

      moduleDataGetList(vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          moduleDataEdit({
            id: vm.windowAddItem.id,
            bbsOrderAm: vm.windowAddItem.bbsOrderAm,
            bbsOrderXg: vm.windowAddItem.bbsOrderXg,
            indexOrderAm:vm.windowAddItem.indexOrderAm,
            indexOrderXg:vm.windowAddItem.indexOrderXg
          }).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
